import { render, staticRenderFns } from "./PButton.vue?vue&type=template&id=0b3a5c61&scoped=true&"
import script from "./PButton.vue?vue&type=script&lang=js&"
export * from "./PButton.vue?vue&type=script&lang=js&"
import style0 from "./PButton.vue?vue&type=style&index=0&id=0b3a5c61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a5c61",
  null
  
)

export default component.exports